import settings from "@/settings.json";

export const getContentFullUrl = (contentStorageName: string) => {
  return `${settings.ContentSource}${contentStorageName}`;
};

export const getIsEndDatePassed = (endDate: string) => {
  const isEndDatePassed = endDate ? new Date().getTime() > new Date(endDate + "Z").getTime() : false;
  return isEndDatePassed;
};
